const dashboardTranslations = {
  waterInTake: "كمية الماء",
  renewProgramButton: "برجاء تحديث بياناتك",
};

export default dashboardTranslations;
